<template lang="pug">
#publication
  .container-fluid
    #journalisttag.pl-0.py-3.pr-3.d-flex.align-items-center(
      v-if="selectedJournalist['Nombre']",
      key="tag"
    )
      i.fas.fa-chevron-left.pl-1.pr-3.large(@click="goBack()")
      p.col-11.my-0.px-0 {{ selectedJournalist['Nombre'] }}
        br 
        span.accent-text Fecha de asesinato: {{ selectedJournalist['Fecha de asesinato'] }}
    .row.publication.justify-content-center.d-flex(
      v-if="selectedPublication['Archivo'] !== 'Video'"
    )
      .col-12
        h4.title {{ selectedPublication['Título'] }}
      .col-12.col-md-6 
        p.publication-details.mt-1.mb-0.bold Periodista: {{ selectedPublication['Periodista'] }}
        p.publication-details.mt-1.mb-0 Fecha de publicación: {{  (new Date(selectedPublication["FDP"]).toLocaleDateString('es-mx', {dateStyle: "medium"}))  }}
        p.publication-details.mt-1.mb-0 Publicación: {{ selectedPublication['Medio'] }}
        p.publication-details.mt-1.mb-0 Plataforma: {{  selectedPublication["Plataforma"] ? selectedPublication["Plataforma"].join(", ") : ''  }}
      .col-12.col-md-6
        p.publication-details.mt-1.mb-0 Estado: {{ selectedPublication['Estado'] }}
        p.publication-details.mt-1.mb-0 Municipio: {{ selectedPublication['Municipio'] }}
        p.publication-details.mt-1.mb-0 Partido municipal: {{ selectedPublication['Partido político Presidente municipal'] }}
        p.publication-details.mt-1.mb-0 Alcalde: {{ selectedPublication['Presidente municipal'] }}
      .col-12.col-md-12.mb-2
        p.publication-details.mt-1.mb-0(
          v-if="selectedPublication['Link'] !== ''"
        ) Link:
          a(
            :href="selectedPublication['Link']",
            target="_blank",
            rel="noreferrer"
          ) &nbsp;{{ selectedPublication['Link'] }}
      .col-12.col-md-12.mb-2
        p.content.mt-3 {{ selectedPublication['Texto'] }}
    .row.publication.justify-content-center.d-flex(
      v-if="selectedPublication['Archivo'] == 'Video' && selectedPublication['Link']"
    )
      .col-12.px-0.px-md-2
        iframe.video(
          width="100%",
          height="500px",
          :src="selectedPublication.play",
          frameborder="0"
        )
      .col-12.mt-3.mt-md-5
        h4.title {{ selectedPublication['Título'] }}
      .col-12.col-md-6 
        p.publication-details.mt-1.mb-0.bold Periodista: {{ selectedPublication['Periodista'] }}
        p.publication-details.mt-1.mb-0 Fecha de publicación: {{  (new Date(selectedPublication["FDP"]).toLocaleDateString('es-mx', {dateStyle: "medium"}))  }}
        p.publication-details.mt-1.mb-0 Publicación: {{ selectedPublication['Medio'] }}
        p.publication-details.mt-1.mb-0 Plataforma: {{  selectedPublication["Plataforma"] ? selectedPublication["Plataforma"].join(", ") : ''  }}
      .col-12.col-md-6
        p.publication-details.mt-1.mb-0 Estado: {{ selectedPublication['Estado'] }}
        p.publication-details.mt-1.mb-0 Municipio: {{ selectedPublication['Municipio'] }}
        p.publication-details.mt-1.mb-0 Partido municipal: {{ selectedPublication['Partido político Presidente municipal'] }}
        p.publication-details.mt-1.mb-0 Alcalde: {{ selectedPublication['Presidente municipal'] }}
      .col-12.col-md-12.mb-2
        p.publication-details.mt-1.mb-0(
          v-if="selectedPublication['Link'] !== ''"
        ) Link:
          a(
            :href="selectedPublication['Link']",
            target="_blank",
            rel="noreferrer"
          ) &nbsp;{{ selectedPublication['Link'] }}
</template>

<script>
export default {
  name: "Publication",
  computed: {
    selectedPublication: {
      get() {
        const publication = this.$store.state.selectedPublication;
        if (publication["Archivo"] == "Video" && publication["Link"]) {
          let play = publication["Link"].replace(/(watch\?v\=)/, "embed/");
          publication.play =
            play.lastIndexOf("&") > -1
              ? play.substring(0, play.lastIndexOf("&"))
              : play;
        }
        return publication;
      },
      set(newValue) {
        this.$store.state.selectedPublication = newValue;
      },
    },
    selectedJournalist: {
      get() {
        return this.$store.state.selectedJournalist;
      },
      set(newValue) {
        this.$store.state.selectedJournalist = newValue;
      },
    },
    allPublications() {
      return this.$store.state.allPublications;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getParams() {
      await this.$store.dispatch("getJournalists");
      const params = this.$route.params.name.replace(/(-)/gi, " ");
      const index = this.$route.params.index;

      this.selectedJournalist = this.$store.state.allJournalists.filter(
        (j) => j["Nombre"] == params
      )[0];
    },
  },
  async mounted() {
    if (!this.selectedJournalist["Nombre"]) {
      await this.getParams();
    }
  },
};
</script>

<style lang="scss">
#publication {
  #journalisttag {
    position: fixed;
    top: 2.5rem;
    left: 0;
    background-color: #141414;
    color: #fff;
    font-size: 15px;
    line-height: 1.2;
    width: 280px;
    transition: 0.5s;
    z-index: 2;
    i {
      &:hover {
        cursor: pointer;
        opacity: 0.85;
      }
    }
  }
  .publication {
    margin: 9rem auto 0 auto;
    max-width: 80%;
  }
}

@media (max-width: 767.98px) {
  #publication {
    .publication {
      max-width: 100%;
      .video {
        height: 300px;
        margin: auto -15px;
        max-width: 100vw;
        width: 100vw;
      }
    }
  }
}
</style>